import { TimeLineStepsEnum } from '@enums/time-line-steps.enum';
import { Component, Input, OnInit } from '@angular/core';

export interface TimelineStep {
  id: number;
  stepName: string;
  stepValidation: TimeLineStepsEnum
}
@Component({
  selector: 'app-time-line',
  templateUrl: './time-line.component.html',
  styleUrls: ['./time-line.component.scss']
})
export class TimeLineComponent {
  VALIDATION_STATUS = TimeLineStepsEnum;
  @Input() timelineSteps = new Array<TimelineStep>();
}
